import {useEffect,useState,useContext } from "react";
import {useNavigate} from "react-router-dom";
import "./Header.scss";
//..............Above Header icon Envelope map instagram facebook Start.............
import {FaEnvelope,FaMapMarkedAlt ,FaPhoneAlt,FaInstagram,FaFacebook,FaWhatsapp } from 'react-icons/fa';
//..............Above Header icon Envelope map instagram facebook Start.............

//..............Import Header Logo ..................
import logo from "../../assets/logo/logo.png";
//..............Main Header Image Icons Start..................

import {TbSearch} from "react-icons/tb";
import {CgShoppingCart} from "react-icons/cg";
import {AiOutlineHeart} from "react-icons/ai";
//..............Main Header Image Icons Start..................
import Search from "./Search/Search";
import Cart from "../Cart/Cart";
import {Context} from "../../utils/context";


const Header = () => {
    const [scrolled,setScrolled] = useState(false);
    const handlescroll = () =>{
        const offset = window.scrollY;
        if(offset>200){setScrolled(true); }
        else{setScrolled(false);}
    };
    useEffect(()=>{window.addEventListener("scroll",handlescroll);},[]);
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => {setIsOpen(!isOpen);};

    return(
        <header className={`main-header ${scrolled ? "sticky-header" :""}`}>
            <div className="header-above" >
                <div className="left-icons">
                    <div className="envelope"><FaEnvelope style={{color:'white', fontSize:'18px'}}/></div>
                    <div className="map"><FaMapMarkedAlt style={{ color: 'white', fontSize: '18px' }}/></div>
                    <a href="https://www.instagram.com/thegrandmachal/?hl=en" target="_blank" rel="noopener noreferrer">
                        <FaInstagram size={18}  alt="Instagram" color="white" />
                        </a>
                    <a href="https://www.facebook.com/thegrandmachal/?hl=en" target="_blank" rel="noopener noreferrer">
                        <FaFacebook size={18}  alt="Facebook" color="white" />
                        </a>
                </div>
                <div className="right-icons">
                    <div className="right-icons-div">
                        <div className="button-booknow"><a href="https://thegrandmachal.com/accommodation.php" ><button>Book Now</button></a></div>
                        <div className="phone"><a href="tel:+911234567890">
                            <FaPhoneAlt style={{ color:'white',fontSize:'18px'}}/></a></div>
                        <a href="https://api.whatsapp.com/send/?phone=918889881928&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp size={18}  alt="Instagram" color="white"/>
                        </a>
                    </div>
                </div>
            </div>
{/**..........................................above header end............................... */}            
                <div style={{display:'flex'}} >
                    <div className="hrline" style={{ justifyContent:'center',margin:'0 0',padding:'0 0',width:'50%',height: '1px',marginLeft:'150px', backgroundColor: '#fff'}}>
                    </div>
                    <div className="hrline" style={{marginLeft:'0px',padding:'0 0',width:'28%',height: '1px',backgroundColor: '#fff'}}>
                    </div>
                </div>
            
 {/**..........................................Header Line end............................... */}             
            <div className="header-content">
                <ul className="left">
                    <li><a href="/">Home</a></li>
                    {/* <li><a>About Us</a></li> */}
                    <li><a href="https://thegrandmachal.com/assets/images/resources/tgm.pdf">Adventure</a></li>
                    <li><a href="https://thegrandmachal.com/accommodation.php">Accommodation</a></li>
                </ul>
                <div className="center">
                    <img src={logo} alt='' classname="logo-cl"/>               
                </div>
                <ul className="left2">
                    <li><a href="https://thegrandmachal.com/restaurant.php">Restaurant</a></li>
                    <li><a href="https://thegrandmachal.com/assets/images/resources/THE%20LEAF%20TARRIF.pdf">Leaf Spa</a></li>
                    <li><a href="https://thegrandmachal.com/event.php">Wedding & Events</a></li>
                    <li><a href="https://thegrandmachal.com/contact.php">Contact Us</a></li>
                </ul>
{/*..........................................mobile menu start.......................................*/}
            <div className="navbar" style={{marginLeft:'200px',marginTop:'36px'}}><button onClick={toggleMenu} className="menu-btn">☰</button></div>
      {/* Overlay */}
                <div className={`overlay ${isOpen ? 'show' : ''}`} onClick={toggleMenu}></div>
      {/* Side Menu */}
                <div className={`side-menu ${isOpen ? 'open' : ''}`}>
                    <button onClick={toggleMenu} className="close-btn">×</button>
                        <ul>
                            <img src={logo} alt='' style={{marginLeft:'45px',width:'100px'}}/>                                        
                            <li><a href="/">Home</a></li>
                           {/*  <li><a href="/about">About</a></li> */}
                            <li><a href="https://thegrandmachal.com/assets/images/resources/tgm.pdf">Adventure</a></li>
                            <li><a href="https://thegrandmachal.com/accommodation.php">Accommodation</a></li>
                                <li><a href="https://thegrandmachal.com/restaurant.php">Restaurant</a></li>
                            <li><a href="https://thegrandmachal.com/assets/images/resources/THE%20LEAF%20TARRIF.pdf">Leaf Spa</a></li>
                            <li><a href="https://thegrandmachal.com/event.php">Wedding & Event</a></li>
                            <li><a href="https://thegrandmachal.com/contact.php">Contact</a></li>
                            <li><a target="_blank" href="https://www.instagram.com/thegrandmachal/?hl=en" className="instagramm" >
                                    <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Instagram" width={30} />
                                </a>
                                <a target="_blank" href="https://www.facebook.com/thegrandmachal/?hl=en" className="mfacebook" style={{marginLeft:'15px'}}>
                                    <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="facebook" width={30} />
                                </a>
                            </li>                 
                        </ul>
                </div>

{/*.....................mobile menu end................................ */}
                 <div className="right">
                    {/* <TbSearch/>
                   <AiOutlineHeart/>  */}
                     {/* <span className="cart-icon"> 
                     <CgShoppingCart/> 
                        <span>5</span>
                     </span>  */}
                </div> 
            </div>   
        </header>
    );   
};
export default Header;